module.exports = "/img/logo2.png?108df29146b19636439be098042df578";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/logo2.png
// module id = tBwz
// module chunks = 54